import React from 'react';
import { Route, Switch } from 'react-router-dom';


 const DefaultPage= () => (
  <Switch>
  </Switch>
);

export default DefaultPage;